/**
 * Field validation helpers for CreateObjectTypeWizard's FormProvider config.
 * Extracted from CreateObjectTypeWizard.tsx to keep that file within the
 * project's file-size convention. Behavior is unchanged — these are the same
 * checks that were previously inlined as closures in the `fields` object.
 */

export function validateDisplayName(
  value: unknown,
  {
    hasTimelineSuffix,
    hasTypeNameCollision,
  }: { hasTimelineSuffix: boolean; hasTypeNameCollision: boolean }
): string | undefined {
  if (!(value as string)?.trim()) {
    return 'Display name is required';
  }
  if (hasTimelineSuffix) {
    return 'Object type names ending in "timeline" are reserved. Please choose a different name.';
  }
  if (hasTypeNameCollision) {
    return 'An object type with this name already exists. Please choose a different name.';
  }
  return undefined;
}

export function validatePluralName(value: unknown): string | undefined {
  return !(value as string)?.trim() ? 'Plural name is required' : undefined;
}

export function validateIcon(value: unknown): string | undefined {
  return value ? undefined : 'Icon is required';
}

export function validateOntologyKind(value: unknown): string | undefined {
  return value ? undefined : 'Pick what kind of thing this is';
}

export function validatePipelineName(
  value: unknown,
  isPipelineable: boolean
): string | undefined {
  return isPipelineable && !(value as string)?.trim()
    ? 'Pipeline name is required'
    : undefined;
}
